import { MijnRoute } from '../../mijn-navigatie.model';

export const INSURANCES: MijnRoute = {
    path: 'verzekeren-beheren',
    navigationEvent: 'toVerzekerenBeheren',
    regex: /^\/verzekeren-beheren$/,
    webcomponent: 'mijn-verzekeren-beheer-webcomponent'
};
